import { CessionRaws, Pagination } from '@factorin/domain';

import { withUrl, list } from '../rest';


interface CessionRawListRequest extends Pagination.Request {
    batchUId?: string;
    cessionNumber?: string;
    additionalSupplyNumber?: string;
}

const sessionRawsPart = withUrl('cessionraws');

export const cessionraws = list<CessionRaws.CessionRaw, CessionRawListRequest>(sessionRawsPart());
